import { apiRequest } from '@/utils/api-request';
import { useOrgStore } from '@/stores/org-store';

export interface DeleteApiKeyProps {
  id: string;
}

export const deleteCapitolKey = async ({ id }: DeleteApiKeyProps) => {
  const orgId = useOrgStore.getState().currentOrg?.orgid;

  const response = await apiRequest({
    url: `/internal-api-keys/${orgId}/${id}`,
    target: 'platform',
    method: 'DELETE',
  });

  if (response?.detail) {
    throw new Error(response.detail || 'Failed to delete capitol key');
  }

  return response;
};
